import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import parse from 'html-react-parser';

const JobDetailsDescription = ({ title, content }) => (
  <Box py={4} px={{ base: 2, md: 6 }}>
    <Text fontWeight="bold" fontSize={{ base: 'lg', md: 'xl' }} mb={2}>{title}</Text>
    <Box color="gray.700" fontSize={{ base: 'sm', md: 'md' }}>
      {typeof content === 'string' && content.includes('<') ? parse(content) : content}
    </Box>
  </Box>
);

export default JobDetailsDescription; 